import React, { Component } from "react";

import "./BaseInputComponent.scss";

export interface InputProps {
    field?: any;
    form?: any;
    inputtype?: string;
    placeholder?: string;
    givenid?: string;
}

export default class BaseInputComponent extends Component<InputProps, {}> {
    render() {
        const fieldName = this.props.field.name;

        const errors =
            this.props.form.touched[fieldName] &&
            this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                <span className="input-error-message">{errors}</span>
            </div>
        );

        return (
            <div id={this.props.givenid + "Input"}>
                <div
                    className={
                        "input-group " + (errors ? "input-group-error" : "")
                    }
                >
                    <input
                        type={this.props.inputtype}
                        className="input"
                        placeholder={this.props.placeholder}
                        spellCheck={false}
                        {...this.props.field}
                        {...this.props}
                    />
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
